import { IUAH, UAH } from '@smart-kasa/ui';

export interface ICurrencyProps extends IUAH {}

export const Currency = (props: ICurrencyProps) => <UAH precision={2} {...props} />;
